<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
    <div :class="$style.container">
      <div :class="$style.banner">
        <img :src="bannerBackground" alt="" />
      </div>
      <div :class="$style.gameDetail">
        <div>
          <img :src="gameDetail.logo" alt="" :class="$style.icon" />
          <div :class="$style.info">
            <p :class="$style.name">{{ gameDetail.appName }}</p>
            <p :class="$style.categoryNames">
              {{
                gameDetail.categoryNames && gameDetail.categoryNames.join("·")
              }}
            </p>
            <p :class="$style.tags">
              <span
                v-for="item in gameDetail.tags"
                :key="item.id"
                :style="{ color: item.labelInfo }"
                >{{ item.labelName }}</span
              >
            </p>
          </div>
          <button :class="$style.download" @click="onHandleGame(false)">
            查看/下载
          </button>
        </div>
      </div>
      <div :class="$style.punch">
        <span :class="$style.statistics">累计打卡{{ signDays }}天</span>
        <div :class="$style.redirect">
          <span @click="onSkipPage('RULE')">活动规则</span>
          <span @click="onSkipPage('RECORDS')">领取记录</span>
        </div>
        <div :class="$style.giftList">
          <div
            :class="$style.giftItem"
            v-for="(item) in giftList"
            :key="item.id"
          >
            <div :class="$style.giftIcon">
              <img :src="item.giftIcon" alt="" />
            </div>
            <div :class="$style.info">
              <p :class="$style.title">{{ item.giftName }}</p>
              <p :class="$style.condition">
                {{ `打卡满${item.type}天可领取` }}
              </p>
              <p :class="$style.detail">{{ item.giftDetail }}</p>
            </div>
            <button
              v-if="signDays >= item.type && !item.draw"
              :class="$style.unBtn"
              @click="receiveGift(item)"
            >
              领取
            </button>
            <button
              v-else-if="item.draw"
              :class="$style.yBtn"
              @click="receiveGift(item)"
            >
              已领取
            </button>
            <button v-else :class="$style.nBtn">
              打卡{{ item.type }}天可领
            </button>
          </div>
        </div>
        <div :class="$style.punchBtn" id="footerBtn">
          <span
            v-if="signStatus !== 3 && signStatus !== 2"
            :class="$style.bubble"
            >{{ bubble }}</span
          >
          <button v-if="signStatus == 0" @click="punchIn">点我打卡</button>
          <button v-if="signStatus == 1">今日已打卡</button>
          <button v-if="signStatus == 2">活动已结束</button>
          <button v-if="signStatus == 3" @click="unSatisfiedHint">
            不满足活动条件
          </button>
        </div>
      </div>
      <div :class="$style.dialog" v-if="dialogVisible">
        <header>
          <span>{{ dialogTitle }}</span>
          <img
            :src="closeImg"
            alt=""
            :class="$style.close"
            @click="dialogVisible = false"
          />
        </header>
        <main>
          <div v-if="dialogType === 0">
            <p :class="$style.bt">已累计打卡{{ signDays }}天</p>
            <p>
              累计签到打卡<span
                >1、3{{ giftList.length > 2 ? "、5、" : ""
                }}{{ giftList.length > 3 ? "7" : "" }}天</span
              >
            </p>
            <p>可领取礼包</p>
            <p><span>明天记得也来打卡哦~</span></p>
          </div>
          <div v-if="dialogType === 1">
            <p style="text-align: center; margin-bottom: 10px;">礼包码已存放在</p>
            <p style="text-align: center; width: 100%;"><span>【我的】</span>-<span>【我的礼包】</span>-<span>【活动礼包】</span></p>
          </div>
          <div v-if="dialogType === 2">
            <p style="text-align: center">
              当前账号在<span>[{{ gameDetail.appName }}]</span>中
            </p>
            <p style="text-align: center">没有游戏记录，进入游戏</p>
            <p style="text-align: center">后可参与活动。</p>
          </div>
          <div v-if="dialogType === 3">
            <p>兑换码生成错误，请联系客服领取备用码</p>
          </div>
          <div
            :class="$style.btnGroup"
            :style="{
              justifyContent: dialogType === 0 ? 'center' : 'space-between',
            }"
          >
            <button
              v-if="![0].includes(dialogType)"
              :class="$style.cancelBtn"
              @click="onClickCancel(dialogType)"
            >
              {{ cancelText }}
            </button>
            <!-- :data-clipboard-text="cdk" -->
            <button
              v-if="dialogType === 1"
              :class="`${$style.sureBtn} copy-btn`"
              @click="onGoGiftDetail"
            >
              {{ sureText }}
            </button>
            <button
              v-else-if="dialogType === 2"
              @click="onHandleGame(true)"
              :class="$style.sureBtn"
            >
              {{ sureText }}
            </button>
            <button
              v-else-if="dialogType === 3"
              @click="onRelationServer"
              :class="$style.sureBtn"
            >
              {{ sureText }}
            </button>
            <button
              v-else
              :class="$style.sureBtn"
              @click="onSureSignIn"
            >
              {{ sureText }}
            </button>
          </div>
        </main>
      </div>
      <div :class="$style.mask" v-if="dialogVisible"></div>
    </div>
  </PullRefresh>
</template>
<script>
import {
  gamePlacesBanner,
  gamePlacesSign,
  gamePlacesMainList,
  gamePlacesGiftReceiveV2,
  getClockInGiftsV2,
  clockInOptV2,
} from "@/apis/actPlace";
import { CDN_URL_1, CDN_URL } from "@/config";
import Clipboard from "clipboard";
import { getCookie, pageLoseTips } from "@/libs/utils";
import { setPageTitle, jumpToNative } from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import { burnPoint } from "@/apis/heziShare";

export default {
  data() {
    return {
      pageTitle: "打卡活动",
      gameId: "",
      bannerBackground: "",
      icon: "",
      closeImg: `${CDN_URL}/packet/close.png`,
      gameDetail: {}, // 游戏下载详情
      giftList: [], // 礼包列表
      signDays: 0, // 签到天数
      signStatus: 0, // 当天签到状态
      bubble: "", // 签到气泡🫧
      days: [1, 3, 5, 7],
      CDN_URL_1,
      dialogVisible: false,
      dialogType: 0, // 0. 打卡 1. 礼包领取成功 2.不满足活动条件 3.礼包码生成错误
      dialogTitle: "打卡成功",
      cancelText: "开启提醒",
      sureText: "我知道了",
      cdk: "", // 当前礼包cdk
      giftName: "", // 当前领取礼包名称
      giftId: "", // 当前领取礼包id
      isLoading: false,
      cookie: null,
      activityGiftId: '',
    };
  },
  mounted() {
    this.copyInit();
  },
  created() {
    // 页面初始化
    this.getBaseInfo();
  },
  watch: {},
  computed: {
    activityId () {
      return this.$route.query.id || ''
    },
  },
  activated() {
    if (!this.gameId) {
      this.gameId = localStorage.getItem("actGameId");
    }
    this.dialogVisible = false;
    this.onScrollFooter();
  },

  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.getBaseInfo();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    // 调整页面滚动位置
    onScrollFooter() {
      this.$nextTick(() => {
        setTimeout(() => {
          document.getElementById("footerBtn").scrollIntoView({
            behavior: 'smooth'
          });
        }, 200);
      });
    },
    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event)
      burnPoint({
        ...this.cookie,
        ...data,
        appName: this.gameDetail.appName,
        appkey: this.gameId,
      }).catch((err) => console.log(err));
    },
    async getBaseInfo() {
      const { history } = this.$router;
      const { query } = history.current;
      if (query.title) {
        this.pageTitle = query.title;
        setPageTitle(query.title);
        document.title = query.title;
      }
      if (query.gameId) {
        this.gameId = query.gameId;
        localStorage.setItem("actGameId", this.gameId);
      }
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      if (this.gameId) {
        getClockInGiftsV2({
          activityId: this.activityId,
          activityGameId: this.gameId
        }).then(res => {
          const {
            gameInfo, giftVos, totalSignDays, 
            signStatus, bubble, activityGiftId,
            background
          } = res.data
          this.bannerBackground = background
          this.gameDetail = gameInfo
          this.giftList = giftVos
          this.signDays = totalSignDays;
          this.signStatus = signStatus;
          this.bubble = bubble;
          this.activityGiftId = activityGiftId
          this.eventTrack({
            event: "activity_branch",
            event_field: JSON.stringify({ activity_name: this.pageTitle }),
          });
        })
      }
    },
    async punchIn() {
      this.eventTrack({
        event: "activity_sign",
        event_field: JSON.stringify({ activity_name: this.pageTitle }),
      });
      clockInOptV2({
        activityId: this.activityId,
        activityGameId: this.gameId
      }).then(res => {
        this.dialogVisible = true;
        this.dialogType = 0;
        this.dialogTitle = "打卡成功";
        this.cancelText = "开启提醒";
        this.sureText = "我知道了";
        this.signStatus = 1;
        this.signDays = res.data.signDays
        this.eventTrack({
          event: "activity_sign_pop",
          event_field: JSON.stringify({
            activity_name: this.pageTitle,
            contin_days: this.signDays,
          }),
        });
        // 领取后刷新页面
        this.onRefresh();
      })
    },
    onClickCancel(dialogType) {
      this.dialogVisible = false;
      if (dialogType === 0) {
        // 跳转通知权限系统设置
        // this.eventTrack({
        //   event: 'activity_sign_pop_open_tip',
        //   event_field:JSON.stringify({ activity_name: this.pageTitle,contin_days: this.signDays}),
        // });
      }
    },
    async receiveGift(giftInfo) {
      const { giftId: id, cdk, giftName, type, draw } = giftInfo;
      const receivable = this.signDays >= type && !draw
      const nextStep = () => {
        this.giftName = giftName;
        this.giftId = id;
        this.dialogType = 1;
        this.dialogTitle = "领取成功";
        this.cancelText = '取消'
        this.sureText = "查看礼包码";
        this.dialogVisible = true;
      };
      if (receivable) {
        this.eventTrack({
          event: "activtiy_gift_get",
          event_field: JSON.stringify({
            activity_name: this.pageTitle,
            gift_id: id,
            gift_name: giftName,
          }),
        });
        gamePlacesGiftReceiveV2({
          activityId: this.activityId,
          activityGameId: this.gameId,
          activityGiftId: this.activityGiftId,
          type,
        })
          .then((r) => {
            this.cdk = r.data.cdk;
            this.eventTrack({
              event: "activity_gift_get_pop",
              event_field: JSON.stringify({
                activity_name: this.pageTitle,
                gift_id: id,
                gift_name: giftName,
                get_result: this.cdk ? 1 : 2,
              }),
            });
            this.onRefresh();
            if (this.cdk) {
              nextStep();
            } else {
              this.dialogType = 3;
              this.dialogTitle = "提示";
              this.cancelText = "取消";
              this.sureText = "联系客服";
              this.dialogVisible = true;
              this.giftName = giftName;
              this.giftId = id;
            }
          })
          .catch((err) => {
            if (err.code === 90008) {
              this.dialogType = 3;
              this.dialogTitle = "提示";
              this.cancelText = "取消";
              this.sureText = "联系客服";
              this.dialogVisible = true;
              this.giftName = giftName;
              this.giftId = id;
              this.eventTrack({
                event: "activity_gift_get_pop",
                event_field: JSON.stringify({
                  activity_name: this.pageTitle,
                  gift_id: id,
                  gift_name: giftName,
                  get_result: 2,
                }),
              });
            } else {
              this.$toast(err.msg);
            }
          });
      } else {
        this.cdk = cdk;
        nextStep();
      }
    },
    copyInit() {
      this.copy = new Clipboard(".copy-btn");
    },
    // 不满足活动条件按钮点击
    unSatisfiedHint() {
      this.dialogType = 2;
      this.dialogTitle = "不满足活动条件";
      this.cancelText = "取消";
      this.sureText = "下载/查看游戏";
      this.dialogVisible = true;
      this.eventTrack({
        event: "activity_pop_tip",
        event_field: JSON.stringify({ activity_name: this.pageTitle }),
      });
    },
    onHandleGame(isPop = false) {
      let event = "";
      if (isPop) {
        event = "activity_pop_tip_downgame";
      } else {
        event = "activity_game_scan";
      }
      this.eventTrack({
        event: event,
        event_field: JSON.stringify({ activity_name: this.pageTitle }),
      });
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: 15,
        extraParams: this.gameDetail.gameId,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 礼包详情
    onGoGiftDetail() {
      this.dialogVisible = false;
      this.eventTrack({
        event: "activity_pop_copy_code",
        event_field: JSON.stringify({
          activity_name: this.pageTitle,
          gift_id: this.giftId,
          gift_name: this.giftName,
        }),
      });
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: 3, 
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    onRelationServer() {
      this.dialogVisible = false
      this.eventTrack({
        event: "activity_pop_likeme",
        event_field: JSON.stringify({
          activity_name: this.pageTitle,
          gift_id: this.giftId,
          gift_name: this.giftName,
        }),
      });
      localStorage.setItem("actGameId", this.gameId);
      this.$router.push({
        name: `box.customerService`,
      });
    },
    onSureSignIn () {
      this.dialogVisible = false
      this.eventTrack({
        event: "activity_sign_pop_know_button",
        event_field: JSON.stringify({
          activity_name: this.pageTitle,
          contin_days: this.signDays
        }),
      });
    },
    onSkipPage(type) {
      let path = "";
      let event = "";
      if (type === "RULE") {
        path = "actPlaceRule";
        event = "activity_rule";
      }
      if (type === "RECORDS") {
        path = "actCollectionRecords";
        event = "activity_gift_log";
      }
      this.eventTrack({
        event: event,
        event_field: JSON.stringify({ activity_name: this.pageTitle }),
      });
      this.$router.push({
        name: `box.${path}`,
        params: {
          gameId: this.gameDetail.gameId,
          type: 23,
        },
      });
    },
  },
  components: {
    PullRefresh,
  },
};
</script>
<style lang="scss" module>
.container {
  width: 100vw;
  min-height: 100vh;
  overflow-y: auto;
  padding-top: 10px;
  background: url("#{$cdn-url-2}/box_11/pageBack.jpg") no-repeat;
  background-size: 100% 100%;
  .banner {
    display: block;
    width: 91%;
    // max-height: 220px;
    margin: auto;
    padding: 4px;
    border-radius: 4px;
    background-color: #b91f08;
    > img {
      display: block;
      width: 100%;
      max-height: 196px;
      margin: auto;
    }
  }
  .gameDetail {
    display: block;
    width: 340px;
    height: 92px;
    margin: auto;
    padding: 4px;
    border-radius: 4px;
    background-color: #b91f08;
    margin-top: 10px;
    > div {
      background: linear-gradient(180deg, #fde6d6 0%, #ffd6b5 100%);
      width: 100%;
      height: 100%;
      padding: 10px;
      display: flex;
      align-items: center;
      position: relative;
      .icon {
        width: 66.7px;
        height: 66.7px;
      }
      .info {
        margin-left: 4px;
        .name {
          font-size: 15px;
          font-weight: 500;
          text-align: left;
          color: #333333;
          margin-bottom: 9px;
        }
        .categoryNames {
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #999999;
          margin-bottom: 8px;
        }
        .tags {
          > span {
            background-color: #f2c29e;
            padding: 1px 2px;
            font-size: 12px;
            margin-right: 2px;
          }
        }
      }
      .download {
        position: absolute;
        right: 14px;
        border: none;
        outline: none;
        background: none;
        // width: 59px;
        height: 24px;
        border: 1px solid #fc5f5e;
        border-radius: 12.85px;
        color: #fc5f5e;
        &:active {
          opacity: 0.8;
        }
      }
    }
  }
  .punch {
    display: flex;
    margin: auto {
      top: 10px;
    }
    width: 340px;
    min-height: 430px;
    background: url("#{$cdn-url-2}/box_11/mainBack.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 50px;
    position: relative;
    .statistics {
      position: absolute;
      top: 8px;
      left: 28px;
      font-size: 16.67px;
      font-weight: 700;
      text-align: left;
      color: #f2664e;
    }
    .redirect {
      position: absolute;
      top: 20px;
      right: 10px;
      display: flex;
      justify-content: space-between;
      width: 110px;
      > span {
        font-weight: 500;
        text-align: center;
        color: #ffdd3c;
        line-height: 12.85px;
        font-size: 12px;
        border-bottom: 1px solid #ffdd3c;
      }
    }
    .process {
      width: 30px;
      flex: none;
      position: relative;
      > img {
        position: absolute;
        top: 22px;
        left: 5px;
        width: 29px;
      }
      .point {
        background-color: #b62d20;
        width: 4px;
        height: 4px;
        border-radius: 50%;
      }
      .point1 {
        position: absolute;
        top: 70px;
        left: 11px;
        z-index: 10;
      }
      .point2 {
        position: absolute;
        top: 160px;
        left: 11px;
        z-index: 10;
      }
      .point3 {
        position: absolute;
        top: 250px;
        left: 11px;
        z-index: 10;
      }
    }
    .giftList {
      width: 100%;
      padding: 8px;
      height: 324px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      .giftItem {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 15px;
        .giftIcon {
          width: 69px;
          height: 69px;
          background-color: #fde3d1;
          border-radius: 50%;
          border: 2px solid #ffa25d;
          display: flex;
          justify-content: center;
          align-items: center;
          flex: none;
          margin-right: 2px;
          > img {
            width: 45px;
          }
        }
        .info {
          width: 150px;
          margin-right: 2px;
          .title {
            font-size: 15px;
            font-weight: 700;
            color: #833d13;
            margin-bottom: 4px;
          }
          .condition {
            font-size: 11px;
            color: #dc4026;
            margin-bottom: 5px;
          }
          .detail {
            font-size: 10px;
            color: #9f5829;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden; //溢出内容隐藏
            text-overflow: ellipsis; //文本溢出部分用省略号表示
            display: -webkit-box; //特别显示模式
            -webkit-line-clamp: 2; //行数
            line-clamp: 2;
            -webkit-box-orient: vertical; //盒子中内容竖直排列
          }
        }
        .unBtn,
        .yBtn,
        .nBtn {
          flex: none;
          border: none;
          outline: none;
          width: 80px;
          height: 28px;
          background: url("#{$cdn-url-2}/box_11/getButton.png") no-repeat;
          background-size: 100% 100%;
          border-radius: 11.46px;
          box-shadow: 0px -1.39px 0px 1.39px rgba(255, 182, 118, 0.5) inset;
          font-size: 9.72px;
          font-family: Source Han Sans CN, Source Han Sans CN-Bold;
          font-weight: 700;
          text-align: center;
          color: #469646;
          &:active {
            opacity: 0.8;
          }
        }
        .yBtn {
          color: #909090;
        }
        .nBtn {
          color: #c93508;
        }
      }
    }
    .punchBtn {
      position: absolute;
      bottom: 10px;
      left: 0;
      right: 0;
      margin: auto;
      width: 270.83px;
      height: 41.67px;
      > button {
        width: 100%;
        height: 100%;
        background: #fd383c;
        border-radius: 20.83px;
        border: none;
        outline: none;
        color: #ffffff;
        font-size: 15px;
        &:active {
          opacity: 0.8;
        }
      }

      .bubble {
        position: absolute;
        top: -15px;
        right: -30px;
        background: url("#{$cdn-url-2}/box_11/bubble.png") no-repeat;
        background-size: 100% 100%;
        width: 120px;
        height: 30px;
        font-size: 12px;
        text-align: center;
        color: #ffffff;
        padding-top: 5px;
        z-index: 10;
      }
    }
  }
  .dialog {
    width: 306px;
    height: 300px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: #ffffff;
    z-index: 100;
    border-radius: 4px;
    overflow: hidden;
    > header {
      display: flex;
      background: linear-gradient(90deg, #ff782c 0%, #ffb503 100%);
      font-size: 19px;
      color: #ffffff;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      height: 37px;
      .close {
        position: absolute;
        top: 8px;
        right: 10px;
        width: 16px;
        height: 16px;
      }
    }
    > main {
      text-align: center;
      padding-top: 30px;
      .bt {
        font-size: 18px;
        font-weight: 700;
        color: #ff612c;
        margin-bottom: 30px;
        text-align: center;
      }
      p {
        width: 230px;
        margin: auto;
        text-align: left;
        font-size: 16px;
        line-height: 24px;
        > span {
          color: #ff612c;
        }
      }
      .hint {
        font-size: 13px;
        color: #666666;
      }
    }
    .btnGroup {
      position: absolute;
      bottom: 20px;
      display: flex;
      justify-content: space-between;
      width: 80%;
      left: 0;
      right: 0;
      margin: auto;
      > button {
        border: none;
        outline: none;
        width: 105px;
        height: 35px;
        font-size: 13px;
        border-radius: 35px;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        &:active {
          opacity: 0.8;
        }
      }
      .cancelBtn {
        background: #fff2f2;
        color: #fc5f5e;
      }
      .sureBtn {
        background: #fd383c;
        color: #ffffff;
      }
    }
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;
  }
}
</style>
